import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function ThankYouPage() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  useEffect(() => {
    const checkAuth = () => {
      const authData = localStorage.getItem('ftl_auth');
      if (authData) {
        try {
          const parsed = JSON.parse(authData);
          setIsAuthenticated(!!parsed && !!parsed.access_token);
        } catch (e) {
          console.error('Error parsing auth data:', e);
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }
    };
    
    checkAuth();
  }, []);
  
  const handleBackClick = () => {
    if (isAuthenticated) {
      navigate('/candidate');
    } else {
      navigate('/');
    }
  };
  
  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', background: '#f9f9f9' }}>
      <Paper sx={{ p: 5, borderRadius: 3, maxWidth: 480, textAlign: 'center' }} elevation={3}>
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
          Thank You for Applying!
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Your application has been submitted successfully.
          {!isAuthenticated && (
            <>
              <br />
              To keep track of your applications and discover more job opportunities, consider creating an account.
            </>
          )}
        </Typography>
        {!isAuthenticated && (
          <>
            <Button variant="contained" color="primary" sx={{ mb: 2 }} onClick={() => navigate('/signin')}>
              Create Account
            </Button>
            <br />
          </>
        )}
        <Button 
          variant="outlined" 
          color="primary" 
          onClick={handleBackClick}
        >
          Back to Home
        </Button>
      </Paper>
    </Box>
  );
}
